import RefreshTokenInterface from '@/utilities/auth/azure/interfaces/RefreshTokenInterface'
import AxiosService from '@/utilities/service/AxiosService'
import AzurePluginInterface from '@/utilities/auth/azure/interfaces/AzurePluginInterface'
import TokenManagerInterface from '@/utilities/auth/azure/interfaces/TokenManagerInterface'
import { VueJwtDecodeType } from 'vue-jwt-decode'
import { AxiosRequestConfig } from 'axios'
import Authentication from '@/utilities/auth/Authentication'

export default class RequestWatcher implements RefreshTokenInterface {
  private readonly service: AzurePluginInterface
  private readonly tokenManager: TokenManagerInterface
  private readonly jwtDecode: VueJwtDecodeType

  constructor(service: AzurePluginInterface, tokenManager: TokenManagerInterface, jwtDecode: VueJwtDecodeType) {
    this.service = service
    this.tokenManager = tokenManager
    this.jwtDecode = jwtDecode
  }

  watch(httpService: AxiosService, success: (token: string, request?: AxiosRequestConfig) => void, error: () => void): void {
    httpService.axios.interceptors.request.use(
      async (request: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
        const tokens = this.tokenManager.getTokens()
        const { token } = tokens

        if (!token) {
          error()
          return request
        }

        const auth = new Authentication(tokens, this.jwtDecode)

        if (token && !auth.isExpired()) {
          return request
        }

        try {
          const { idToken } = await this.service.refreshToken(token)

          success(idToken, request)
        } catch (e) {
          error()
        }

        return request
      },
    )
  }
}
